
import { Component, Vue, Watch } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { convertCasesForTable } from "@/models/cases_employer";
import { SMUser } from "@/store";

import EmployerServicesTableCA from "@/modules/Services/Components/Table/EmployerServicesTables/EmployerServicesTableCA.vue";

const ICONS = {
  search: "search",
};

@Component({
  components: {
    EmployerServicesTableCA,
  },
})
export default class ExpertCompanyServices extends Vue {
  loading = false;

  items = [];

  get showSlTab() {
    return !(SMUser.isSponsor && !SMUser.user?.is_sl_started);
  }

  get casesCounter() {
    return this.items?.length ?? "0";
  }

  get counterLabel() {
    const count = this.casesCounter;

    if (count === 1) return this.$tc("header.counter", 1, { count });

    return this.$tc("header.counter", 2, { count });
  }

  query = "";

  get searchBarProps() {
    return {
      iconPrepend: ICONS.search,
      placeholder: this.$tc("searchbar.placeholder"),
    };
  }

  get companyId(): number {
    return Number(this.$route.params.company_id ?? 0);
  }

  async fetchItems(search?: string): Promise<void> {
    if (!this.companyId) return;
    try {
      this.loading = true;

      const params = {};

      if (search) Object.assign(params, { search });

      const { data } = await this.axios.get(
        API_ROUTES.EXPERT_COMPANIES_SERVICES(this.companyId, params)
      );

      if (!data) return;

      this.items = data.map((a) => convertCasesForTable(a));
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    this.fetchItems();
  }

  updateQuery(query: string): void {
    // if (query.length < 3 && query.length > 0) return;

    this.fetchItems(query);
  }

  @Watch("query")
  queryChanged(query: string) {
    this.updateQuery(query);
  }

  @Watch("serviceTableTarget")
  serviceTableTargetChanged(value: string) {
    if (!value) return;

    this.fetchItems(this.query);
  }
}
